// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"248aa6c0","421":"570de241","854":"bd1bda4b"}[chunkId] + ".chunk.js";
};